import React, { useState } from "react"
import * as Style from "./CourseSidebar.module.scss"
import Logo from "../../images/bigLogo.svg"
import SmallLogo from "../../images/smallLogo.svg"
import { Link } from "gatsby"
import BackArrow from "../../images/backArrow.svg"
import CourseSidebarVideo from "../CourseSidebarVideo/CourseSidebarVideo"
import SearchInput from "../SearchInput/SearchInput"
import Hamburger from "../../images/hamburger.svg"
import X from "../../images/x.svg"
import Button from "../UI/button/Button"

const CourseSidebar = ({ course, lesson_id, watchedVids }) => {
  let list_number = 0
  let list_number2 = 0

  const [query, setQuery] = useState("")
  const [showSidebar, setShowSidebar] = useState(false)

  const sendChildData = val => {
    setQuery(val)
  }

  const ShowSidebar = () => {
    setShowSidebar(true)
  }

  const HideSidebar = () => {
    setShowSidebar(false)
  }

  return (
    <>
      <div className={Style.header}>
        <Hamburger className={Style.menu} onClick={ShowSidebar} />
        <Button style={Style.button}>Плати</Button>
        <SmallLogo className={Style.header_logo} />
      </div>
      <div
        className={
          showSidebar
            ? `${Style.dark_layer} ${Style.show}`
            : `${Style.dark_layer} ${Style.hide}`
        }
      ></div>
      <div
        className={
          showSidebar
            ? `${Style.sidebar} ${Style.show}`
            : `${Style.sidebar} ${Style.hide}`
        }
      >
        <div className={Style.logo_wrapper}>
          <X className={Style.x} onClick={HideSidebar} />
          <Logo className={Style.logo} />
        </div>
        <div className={Style.back}>
          <BackArrow />
          <Link to="/courses">Към платформата</Link>
        </div>
        <SearchInput sendChildData={sendChildData} />
        <div className={Style.course_name}>{course.title}</div>
        <div className={Style.scrollable}>
          <div className={Style.videos}>
            <div className={Style.title}>Free preview</div>
            {course.lessons
              .filter(video => {
                if (query === "") {
                  return video
                } else if (
                  video.title.toLowerCase().includes(query.toLowerCase())
                ) {
                  return video
                }
              })
              .map((video, index) => {
                if (video.free) {
                  list_number = list_number + 1
                }
                return (
                  video.free && (
                    <CourseSidebarVideo
                      key={index}
                      video={video}
                      list_number={list_number}
                      lesson_id={lesson_id}
                      watchedVids={watchedVids}
                    />
                  )
                )
              })}
          </div>
          <div className={Style.videos}>
            <div className={Style.premium_title}>Available in premium</div>
            {course.lessons
              .filter(video => {
                if (query === "") {
                  return video
                } else if (
                  video.title.toLowerCase().includes(query.toLowerCase())
                ) {
                  return video
                }
              })
              .map((video, index) => {
                if (!video.free) {
                  list_number2 = list_number2 + 1
                }
                return (
                  !video.free && (
                    <CourseSidebarVideo
                      key={index}
                      video={video}
                      list_number={list_number2}
                      lesson_id={lesson_id}
                      watchedVids={watchedVids}
                    />
                  )
                )
              })}
          </div>
        </div>
      </div>
    </>
  )
}

export default CourseSidebar
